/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Asset} from '@ion/core/src/types/entities';
import {AssetMoveEditor} from '@ion/dls/src/editors/AssetMoveEditor';
import {moveAdminAssets, moveAssets} from './state';

export interface BulkAssetEditorProps {
  isCtcAdmin?: boolean;
  globalGroup: any;
  setItemSelected?: Function
}

/**
 * BulkEditAssetEditor
 *
 */
export const BulkEditAssetEditor = ({
  globalGroup,
  isCtcAdmin = false,
  setItemSelected = () => {}
}: BulkAssetEditorProps) => {
  const dispatch = useDispatch();
  const {
    selected: selectedAssets,
    result: editedAssets,
    loading
  } = useSelector(({adminAssets: {move}}) => move);
  const [clearForm, setClearForm] = useState(false);

  useEffect(() => {
    if (editedAssets) {
      setClearForm(true);
      dispatch(moveAdminAssets(null, false));
    }
  }, [editedAssets]);

  return (
    <AssetMoveEditor open
      account={globalGroup}
      assets={selectedAssets}
      clear={clearForm}
      loading={loading}
      isCtcAdmin={isCtcAdmin}
      onSave={function(assets: Asset[]) {
        dispatch(moveAssets(assets));
        setItemSelected(false);
      }}
      onCancel={function() {
        dispatch(moveAdminAssets(null, false));
      }} />
  );
};

export default BulkEditAssetEditor;
